import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Home from './pages/home';
import FAQ from './pages/faq';
import Signup from './pages/signup'
import Testapi from './pages/testapi';
import ProtectedRoutes from './utils/ProtectedRoutes';
import Signin from './pages/signin';
import UserList from './pages/userlist';
import Layout from './pages/layout';
import About from './pages/about';

import Catalog from './pages/Catalog/Catalog';
import PostProject from './pages/postProject/postProject';
import Find from './pages/Find/postproject';
import Project from './pages/Find/project';

function App() {
              

  return (

        <Routes>
            <Route element={<Layout />}>
              <Route path="/" element={<Home />} />
              <Route path='/catalog' element={<Catalog />} />
              <Route path='/about' element={<About />} />
              <Route path='/signup' element={<Signup />} />
              <Route path="/login" element={<Signin />} />

              <Route path="/faq" element={<FAQ />} />
              <Route element={<ProtectedRoutes />} >
                <Route path="/list" element={<UserList />} />
                <Route path='/post' element={<PostProject />} />
                <Route path='/find' element={<Find/>} />
                <Route path='/testapi' element={<Testapi />} />
                <Route path="/project/:id"  element={<Project />} />

              </Route >
            </Route>
        </Routes>

  );
}

export default App;